import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { LearningHubRoutingModule } from './learning-hub-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { LearningHubService } from './services/learning-hub.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { LearningHubComponent } from './pages/learning-hub/learning-hub.component';
import { LearningHubDetailsComponent } from './pages/learning-hub-details/learning-hub-details.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { AgmCoreModule } from '@agm/core';

@NgModule({
  declarations: [

  
    LearningHubComponent,
         LearningHubDetailsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    LearningHubRoutingModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    InfiniteScrollModule,
    SwiperModule,
    AgmCoreModule
  
  ],
    providers:[LearningHubService]
})
export class LearningHubModule {}
